import React, { Component } from 'react'

export default class FieldInfoText extends Component {

    render() {
        return (
            <div>
              {this.props.children}
            </div>
        )

    }

}
